module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_17.81998dad.jpeg";